export * from './googleTagManagerHelper';

import googleTagManagerHelper from './googleTagManagerHelper';

export default googleTagManagerHelper;
